import { render, staticRenderFns } from "./pic_home.vue?vue&type=template&id=c03ca0ee&scoped=true"
import script from "./pic_home.vue?vue&type=script&lang=js"
export * from "./pic_home.vue?vue&type=script&lang=js"
import style0 from "./pic_home.vue?vue&type=style&index=0&id=c03ca0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03ca0ee",
  null
  
)

export default component.exports